import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { SPLIT_CONTAINER_CONVERTER_TOKEN, SplitContainerConverter } from './split-container.component.converter'
import {
  SPLIT_CONTAINER_CONTENT_TEXT_CONVERTER_TOKEN, SplitContainerContentTextConverter
} from './split-container-content-text/split-container-content-text.component.converter'
import {
  SPLIT_CONTAINER_CONTENT_BUTTON_CONVERTER_TOKEN, SplitContainerContentButtonConverter
} from './split-container-content-button/split-container-content-button.component.converter'
import {
  SPLIT_CONTAINER_AGENDA_TABLE_CONVERTER_TOKEN, SplitContainerAgendaTableConverter
} from './split-container-agenda-table/split-container-agenda-table.component.converter'
import {
  SPLIT_CONTAINER_AGENDA_TABLE_ROW_CONVERTER_TOKEN, SplitContainerAgendaTableRowConverter
} from './split-container-agenda-table/split-container-agenda-table-row/split-container-agenda-table-row.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        panelRowVideoImageXLFeature: {
          module: () => import('./split-container.module').then((m) => m.SplitContainerModule),
          cmsComponents: ['split_container'],
        },
      }
    }),
    {
      provide: SPLIT_CONTAINER_CONVERTER_TOKEN,
      useExisting: SplitContainerConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        split_container: SPLIT_CONTAINER_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: SPLIT_CONTAINER_CONTENT_TEXT_CONVERTER_TOKEN,
      useExisting: SplitContainerContentTextConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        split_container_content_text: SPLIT_CONTAINER_CONTENT_TEXT_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: SPLIT_CONTAINER_CONTENT_BUTTON_CONVERTER_TOKEN,
      useClass: SplitContainerContentButtonConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        split_container_content_button: SPLIT_CONTAINER_CONTENT_BUTTON_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: SPLIT_CONTAINER_AGENDA_TABLE_CONVERTER_TOKEN,
      useClass: SplitContainerAgendaTableConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        split_container_agenda_table: SPLIT_CONTAINER_AGENDA_TABLE_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: SPLIT_CONTAINER_AGENDA_TABLE_ROW_CONVERTER_TOKEN,
      useClass: SplitContainerAgendaTableRowConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        split_container_agenda_table_row: SPLIT_CONTAINER_AGENDA_TABLE_ROW_CONVERTER_TOKEN
      },
      multi: true
    },
  ]
})
export class SplitContainerFeatureModule {}
